import { FunctionalComponent } from 'preact';
import { useCallback } from 'preact/hooks';
import { deviceApi, ExitReasonType } from '@accedo/ctv-device-api';
import { Dialog, DialogFooter, DialogHeader, DialogManager } from '@accedo/ctv-ui-dialog';
import { Button as CtvButton } from '@accedo/ctv-ui-button';
import { logger } from '@accedo/logger';
import { usePageNavigation } from '@accedo/page-navigation';
import { DIALOG_TEXT } from '##/constants/text';

const LP = '[ExitDialog]';
export const ExitDialog: FunctionalComponent = () => {
  const { pageState, nav } = usePageNavigation();

  const onCancel = useCallback((): void => {
    DialogManager.close('cancel');
  }, []);

  const onOk = useCallback((): void => {
    DialogManager.close('ok');
    if (deviceApi.exit) {
      deviceApi.exit(ExitReasonType.USER_EXIT);
    }
  }, []);

  logger.debug(`${LP} ExitDialog render`);
  return (
    <Dialog
      id={'ExitDialog'}
      onOpenFocusId="cancel"
      onCloseFallbackFocusId={nav.currentFocusNodeId || pageState.currentFocusNodeId || 'content'}
    >
      <DialogHeader
        alignment="center"
        headerText={DIALOG_TEXT.EXIT_APP_TITLE}
        subHeaderText={DIALOG_TEXT.EXIT_APP_MESSAGE}
      />
      <DialogFooter alignment="end">
        <CtvButton id="cancel" onSelect={onCancel} size="large" buttonType="secondary">
          Cancel
        </CtvButton>
        <CtvButton id="ok" onSelect={onOk} size="large" buttonType="secondary">
          Ok
        </CtvButton>
      </DialogFooter>
    </Dialog>
  );
};

export const ExitDialogElement = <ExitDialog />;
